import type { GetServerSideProps } from "next";
import Head from "next/head";
import { AccountLinkProvider } from "@medbillai/app/lib/accounts-link/accountLinkProvider";
import { AccountsScreen } from "@medbillai/app/screens/accounts-link/accounts-home";
import { AccountLinksDataProvider } from "@medbillai/app/screens/accounts-link/utils/AccountLinksDataProvider";
import { HomeLayout } from "@medbillai/app/screens/home/layout.web";
import { AuthGate } from "../utils/AuthGate";
import { setLongLivedPublicResponseCache } from "../utils/cache";
import type { NextPageWithLayout } from "./_app";
export const getServerSideProps = (({
  res
}) => {
  // Cache the response for a while, since it is unlikely to change.
  setLongLivedPublicResponseCache(res);
  return Promise.resolve({
    props: {}
  });
}) satisfies GetServerSideProps;
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="accounts.tsx">
        <title>Accounts</title>
      </Head>
      <AccountsScreen data-sentry-element="AccountsScreen" data-sentry-source-file="accounts.tsx" />
    </>;
};
Page.getLayout = page => <AuthGate>
    <HomeLayout fullPage backgroundColor="$backgroundSecondary">
      <AccountLinksDataProvider>
        <AccountLinkProvider>{page}</AccountLinkProvider>
      </AccountLinksDataProvider>
    </HomeLayout>
  </AuthGate>;
export default Page;